import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { getStorageItem } from "@/helpers/storage.helpers";
import type {
  DateRangeType,
  PreselectedRangeBMI,
  SelectedDateRange,
} from "@/pages/BMInstructions";
import type { InstructionQuery } from "@/pages/BMInstructions";
import type { SelectedRange } from "@/types/data/redux.types";

export const bmInstructionSliceName = "instructions";

const validRangeTypes: DateRangeType[] = [
  "yesterday",
  "today",
  "last7days",
  "custom",
];

export const defaultRangeType = "last7days";
export const isRangeType = (t: unknown): t is DateRangeType => {
  return validRangeTypes.includes(t as DateRangeType);
};

export const storageKey: PreselectedRangeBMI =
  "bm_instruction_preselected_range";

export type BmInstructionsStateType = {
  bmUnitId: InstructionQuery["bmuid"];
  selectedRange: SelectedRange;
  filter: InstructionQuery["filter"];
};

export const initialState: BmInstructionsStateType = {
  bmUnitId: "",
  selectedRange: {
    type: getStorageItem(storageKey, defaultRangeType),
    from: "",
    to: "",
  },
  filter: "log",
};

export const bmQuerySlice = createSlice({
  name: bmInstructionSliceName,
  initialState,
  reducers: {
    setBmUnitId: (state, action: PayloadAction<string>) => {
      state.bmUnitId = action.payload;
    },
    setSelectedRange: (state, action: PayloadAction<SelectedDateRange>) => {
      state.selectedRange = action.payload;
    },
  },
});

export const { setBmUnitId, setSelectedRange } = bmQuerySlice.actions;

export default bmQuerySlice;
